import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom';
import AuthProvider from './store/AuthProvider';
import ChatProvider from './store/ChatProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
          <ChatProvider>
            <AuthProvider>
                  <HashRouter hashType='noslash' basename='/'>      
                  <App />
                </HashRouter>
            </AuthProvider>
          </ChatProvider>
  </React.StrictMode>
);

